import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Tags panel art: three wrapped rows of tag chips at mixed widths, some in the
 * accent and some muted, each closing with a small count pill.
 */

/** [x, y, width, accent?] */
const CHIPS: [number, number, number, boolean][] = [
  [12, 20, 44, true],
  [62, 20, 34, false],
  [102, 20, 46, false],
  [12, 46, 36, false],
  [54, 46, 50, true],
  [110, 46, 38, false],
  [12, 72, 52, false],
  [70, 72, 30, true],
  [106, 72, 42, false],
]

export function TagsArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {CHIPS.map(([x, y, width, accent]) => (
        <g key={`${x}-${y}`}>
          <rect
            x={x}
            y={y}
            width={width}
            height={14}
            rx={4}
            fill={accent ? 'hsl(var(--primary) / 0.25)' : 'hsl(var(--muted-foreground) / 0.2)'}
          />
          <rect
            x={x + width - 14}
            y={y + 3}
            width={10}
            height={8}
            rx={3}
            fill="hsl(var(--foreground) / 0.2)"
          />
        </g>
      ))}
    </svg>
  )
}
